import type { RecurrenceRule } from './types';

/**
 * Next due date for a recurring task, computed from a base date.
 * Returns undefined for non-recurring rules.
 */
export function nextRecurrence(fromMs: number, rule: RecurrenceRule): number | undefined {
  const d = new Date(fromMs);
  d.setHours(0, 0, 0, 0);
  switch (rule) {
    case 'daily':
      d.setDate(d.getDate() + 1);
      return d.getTime();
    case 'weekly':
      d.setDate(d.getDate() + 7);
      return d.getTime();
    case 'weekdays':
      do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
      return d.getTime();
    default:
      return undefined; // 'none' or unsupported custom rule
  }
}

export const RECURRENCE_LABELS: Record<string, string> = {
  none: 'No se repite',
  daily: 'Cada día',
  weekdays: 'Días laborables',
  weekly: 'Cada semana',
};
